import React from 'react';
import ClientViewCustomizeWrapper from './client-view-customize-wrapper';

export type ReportComponentType =
  | 'metric-universal-display'
  | 'zipcode-heatmap'
  | 'zipcode-rank'
  | 'time-of-day'
  | 'domain-rank'
  | 'app-rank'
  | 'video-completion-rate'
  | 'audio-completion-rate'
  | 'breakdown-table'
  | 'conversions-by-beacon';

interface ReportViewWrapperProps {
  componentType: ReportComponentType;
  className?: string;
  children: React.ReactNode;
  enabled?: boolean;
  defaults?: boolean;
  onStateChange?: (componentType: ReportComponentType, enabled: boolean) => void;
  onFieldSelectionChange?: (componentType: ReportComponentType, selectedFields: string[]) => void;
  onDefaultSelectionChange?: (componentType: ReportComponentType, selectedDefaultTypes: string[]) => void;
  fieldSelection?: boolean;
  bottom?: boolean;
  maxDefaults?: number;
}

const ReportViewWrapper: React.FC<ReportViewWrapperProps> = ({
  componentType,
  className,
  children,
  enabled,
  defaults = true,
  onStateChange,
  onFieldSelectionChange,
  onDefaultSelectionChange,
  fieldSelection = true,
  bottom,
  maxDefaults = 1,
}) => {
  const handleStateChange = (enabledState: boolean) => {
    onStateChange?.(componentType, enabledState);
  };

  const handleFieldSelectionChange = (selectedFields: string[]) => {
    onFieldSelectionChange?.(componentType, selectedFields);
  };

  const handleDefaultSelectionChange = (selectedDefaultTypes: string[]) => {
    onDefaultSelectionChange?.(componentType, selectedDefaultTypes);
  };

  return (
    <ClientViewCustomizeWrapper
      className={className}
      enabled={enabled}
      defaults={defaults}
      onStateChange={handleStateChange}
      onFieldSelectionChange={handleFieldSelectionChange}
      onDefaultSelectionChange={handleDefaultSelectionChange}
      fieldSelection={fieldSelection}
      bottom={bottom}
      key={componentType}
      maxDefaults={maxDefaults}
    >
      {children}
    </ClientViewCustomizeWrapper>
  );
};

export default ReportViewWrapper;
